// import { mapGetters, mapMutations } from 'vuex'
export const GrandWorks = {
  data () {
    return {
      grandList: [],
      dataList: [],
      dataListAll: [],
      limitStart: 0,
      limitPage: 12,
      total: 0,
      totalPage: 0,
      currentPage: 1,
      domainId: 0,
      defaultValue: '',
      loading: true
    }
  },
//   computed: {
//     ...mapGetters(['isLogin'])
//   },
  mounted () {
    if (this.$route.query.domain_id != undefined) {
      this.domainId = this.$route.query.domain_id;
    }
    if (this.$route.params.domainid != undefined) {
      this.domainId = this.$route.params.domainid;
    }
    this.getData();
  },
  methods: {
    // 监听点击star
    monitorStarIcon (id) {
      this.grandList.forEach(item => {
        if (item.id === id) {
          if (item.isCollect) {
            item.star--
          } else {
            item.star++
          }
          item.isCollect = !item.isCollect
        }
      })
    },
    // 点击上传作品
    bindUploadBtn () {
      this.$router.push('/my/uploadworks')
    },
    search() {
      this.currentPage = 1;
      this.getData();
    },
    getData () {
      this.loading = true;
      this.limitStart = (this.currentPage - 1) * this.limitPage;
      var url = this.$root.apiBaseUrl + '?g=api&m=api&a=works_list_api&is_web=1&page_start=' + this.limitStart + '&page_end=' + this.limitPage + '&works_name=' + this.defaultValue + '&domain_id=' + this.domainId;
      if(localStorage.getItem('user_token')) url += '&user_token='+localStorage.getItem('user_token');
      this.$http.get(url).then(function (response) {
        if (response.body.status == 1) {
          this.dataList = response.body.data.works_list;
          this.total = parseInt(response.body.data.page.sum_data_num);
          this.totalPage = parseInt(response.body.data.page.sum_data_page);
        } else {
          this.dataList = [];
          this.total = 0;
          this.totalPage = 0;
        }
        if(1 == this.currentPage) {
          this.dataListAll = this.dataList;
        } else {
          this.dataListAll = this.dataListAll.concat(this.dataList);
        }
        this.loading = false;
      }, function (reserror) {
        this.loading = false;
        console.log(reserror);
      })
    }
  }
}